if (typeof recommendedPaymentsDefined === 'undefined') {
  var recommendedPaymentsDefined = true;

  class RecommendedPayments extends HTMLElement {
    connectedCallback() {
      this.i18n = this.readI18n();
      this.bindVariantListeners();
      // Prefer SSR product price; only refine from the current product view
      const ssr = Number(this.dataset.price || 0);
      if (ssr > 0) this.updatePrice(ssr);
      this.updateFromDomPrice();
    }

    readI18n() {
      const script = this.querySelector('[data-rec-i18n]');
      if (!script) return {};
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return {};
      }
    }

    getProductRoot() {
      return (
        this.closest('.productView') ||
        this.closest('[data-section-type="product"]') ||
        document.querySelector('.productView') ||
        document
      );
    }

    bindVariantListeners() {
      const root = this.getProductRoot();
      root.addEventListener('change', (event) => {
        if (
          !event.target.matches(
            '[name="id"], .product-form__radio, [data-product-attribute] input, select[name^="options"], .select__select'
          )
        ) {
          return;
        }
        window.setTimeout(() => this.updateFromDomPrice(), 50);
      });

      document.addEventListener('variant:change', (event) => {
        const detail = event.detail || {};
        const variant = detail.variant || detail;
        if (variant && typeof variant.price !== 'undefined') {
          this.updatePrice(Number(variant.price));
        }
      });
    }

    updateFromDomPrice() {
      const root = this.getProductRoot();
      const priceRoot =
        root.querySelector('.productView-price') ||
        root.querySelector('[id^="product-price-"]');

      let cents = Number(this.dataset.price || 0);

      if (priceRoot) {
        const last = priceRoot.querySelector('[data-last]');
        if (last && last.dataset.last !== '' && !isNaN(Number(last.dataset.last))) {
          cents = Number(last.dataset.last);
        } else {
          const priceEl = priceRoot.querySelector(
            '.price-item--sale .money, .price-item--sale, .price-item--regular .money, .price-item--regular'
          );
          if (priceEl) {
            const raw =
              priceEl.getAttribute('content') ||
              priceEl.dataset.price ||
              priceEl.textContent;
            const parsed = this.parseMoneyToCents(raw);
            if (parsed != null) cents = parsed;
          }
        }
      }

      this.updatePrice(cents);
    }

    parseMoneyToCents(value) {
      if (value == null) return null;
      if (typeof value === 'number') return Math.round(value);

      const str = String(value).trim();
      if (!str) return null;
      if (/^\d+$/.test(str)) return Number(str);

      const normalized = str
        .replace(/[^\d,.-]/g, '')
        .replace(/\.(?=\d{3}(\D|$))/g, '')
        .replace(',', '.');
      const num = parseFloat(normalized);
      if (isNaN(num)) return null;
      return Math.round(num * 100);
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.dataset.moneyFormat || window.money_format);
      }
      return (Number(cents) / 100).toFixed(2);
    }

    fillTemplate(template, vars) {
      return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
        return vars[key] != null ? vars[key] : '';
      });
    }

    updatePrice(cents) {
      const price = Number(cents) || 0;
      this.dataset.price = String(price);

      const min = Number(this.dataset.minInstallment || 0);
      const klarnaParts = Number(this.dataset.klarnaParts || 3) || 3;
      const paypalParts = Number(this.dataset.paypalParts || 3) || 3;
      const showInstallments = price >= min;

      const klarnaItem = this.querySelector('[data-rec-method="klarna"]');
      const paypalItem = this.querySelector('[data-rec-method="paypal"]');
      const bizumItem = this.querySelector('[data-rec-method="bizum"]');
      const template = this.i18n.installment;

      if (klarnaItem) {
        klarnaItem.hidden = !showInstallments;
        const text = klarnaItem.querySelector('[data-rec-klarna-text]');
        if (text && showInstallments) {
          text.textContent = this.fillTemplate(template, {
            amount: this.formatMoney(Math.floor(price / klarnaParts)),
            count: String(klarnaParts)
          });
        }
      }

      if (paypalItem) {
        paypalItem.hidden = !showInstallments;
        const text = paypalItem.querySelector('[data-rec-paypal-text]');
        if (text && showInstallments) {
          text.textContent = this.fillTemplate(template, {
            amount: this.formatMoney(Math.floor(price / paypalParts)),
            count: String(paypalParts)
          });
        }
      }

      const hasFeatured =
        (klarnaItem && !klarnaItem.hidden) ||
        (paypalItem && !paypalItem.hidden) ||
        Boolean(bizumItem);
      const hasOther = this.dataset.hasOther === 'true';

      this.closest('.productView-moreItem--payments')?.toggleAttribute('hidden', !hasFeatured && !hasOther);
    }
  }

  customElements.define('recommended-payments', RecommendedPayments);
}
